import React, { useState, useEffect } from 'react';
import { Box, Typography, CardContent, Stack, IconButton, CircularProgress } from '@mui/material';
import {
  Email as EmailIcon,
  Phone as PhoneIcon,
  Visibility as VisibilityIcon
} from '@mui/icons-material';
import { ICandidateGroup } from './types';
import { SidebarCard, styles } from './styles';
import Api from '../AgenticScreening/API';
import { useMutation } from '@tanstack/react-query';

export default function ContactInformation({ group }: { group: ICandidateGroup }) {
  const [revealingContacts, setRevealingContacts] = useState(false);
  // If the contacts are revealed, or there are emails or phones already (for recruit candidates), set the contacts revealed to true
  const contactsRevealed =
    group.contacts_revealed || group.emails.length > 0 || group.phones.length > 0;
  const emails = contactsRevealed
    ? group.emails.join(', ') || 'No email provided'
    : '*************';
  const phones = contactsRevealed
    ? group.phones.join(', ') || 'No phone provided'
    : '*************';

  const handleRevealContacts = () => {
    setRevealingContacts(true);
    revealContacts();
  };

  useEffect(() => {
    setRevealingContacts(false);
  }, [group]);

  const { mutate: revealContacts } = useMutation({
    mutationFn: async () => {
      const searchId = /candidate_sourcing\/searches\/(\d+)/.exec(window.location.href)?.[1];
      if (!searchId) return;
      await Api.revealContacts(Number(searchId), [group.id]);
    }
  });

  return (
    <SidebarCard>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={styles.sectionTitle}>
          Contact information
        </Typography>
        <Stack spacing={1} sx={styles.sectionContent}>
          <Box display="flex" alignItems="center" gap={1}>
            <EmailIcon sx={{ fontSize: '16px', color: '#666' }} />
            {revealingContacts ? (
              <CircularProgress size={20} />
            ) : (
              <Typography variant="body2">{emails}</Typography>
            )}
            {!contactsRevealed && (
              <IconButton size="small" onClick={handleRevealContacts}>
                <VisibilityIcon sx={{ fontSize: '14px' }} />
              </IconButton>
            )}
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <PhoneIcon sx={{ fontSize: '16px', color: '#666' }} />
            {revealingContacts ? (
              <CircularProgress size={20} />
            ) : (
              <Typography variant="body2">{phones}</Typography>
            )}
            {!contactsRevealed && (
              <IconButton size="small" onClick={handleRevealContacts}>
                <VisibilityIcon sx={{ fontSize: '14px' }} />
              </IconButton>
            )}
          </Box>
        </Stack>
      </CardContent>
    </SidebarCard>
  );
}
